import { FormattedMessage } from 'react-intl';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { DEFAULT_VALUES } from '@/libraries/web-framework/src/localization/values';
const PerUserAutomation = () => {
	const localizedHref = useLocalizedHref('/software/confluence/automation');
	return (
		<div>
			<p>
				<FormattedMessage
					id="ConfluencePricingPageTeam24.features.perUserAutomation.content.body"
					defaultMessage="Save time by automating repetitive, manual tasks to organize and manage content at scale. Get started quickly with out-of-the box templates or build your own powerful, custom rules by using the low-code / no-code rule builder and with AI. With Premium, unlock up to 1,000 automations per user per month. <a>Learn more.</a>"
					values={{
						...DEFAULT_VALUES,
						a: (chunks) => (
							<a
								data-event="clicked"
								data-event-component="linkButton"
								data-product-key="confluence"
								data-label-english="learn more"
								data-track-event="ConfluencePricingPageTeam24.perUserAutomation.learnMore"
								data-event-container="ConfluencePriceFinderTeam24"
								href={localizedHref}
							>
								{chunks}
							</a>
						),
					}}
				/>
			</p>
		</div>
	);
};
export default PerUserAutomation;
